/* eslint-disable camelcase */
import { ErrorResponse } from 'react-router-dom';
import messages from 'services/locales/en/messages';
import { GetPayoutResponse } from '../responses/responseTypes';

export const transformToPayout = ({
  includes_paid_revenues,
  is_enough_for_payout,
  ...data
}: GetPayoutResponse) => ({
  ...data,
  canWithdraw: is_enough_for_payout,
  includesPaidRevenues: includes_paid_revenues,
});

export const transformToError = (response: ErrorResponse) => {
  const { data } = response;
  if (!data) {
    return { message: messages.error.unknown };
  }
  return { message: data.error_description };
};
